var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.245744 13.2585C0.589494 13.5916 1.14809 13.5916 1.4811 13.2585L6.74477 7.98415L12.0192 13.2585C12.3414 13.5916 12.9108 13.5916 13.2438 13.2585C13.5768 12.9148 13.5768 12.3562 13.2438 12.0339L7.96938 6.75954L13.2438 1.49587C13.5768 1.16286 13.5875 0.593523 13.2438 0.260515C12.9 -0.0617511 12.3414 -0.0617511 12.0192 0.260515L6.74477 5.53493L1.4811 0.260515C1.14809 -0.0617511 0.578752 -0.0724933 0.245744 0.260515C-0.0765216 0.604265 -0.0765216 1.16286 0.245744 1.49587L5.52016 6.75954L0.245744 12.0339C-0.0765216 12.3562 -0.0872638 12.9255 0.245744 13.2585Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit_icon.d3cc7023b61ee82315c873dce369058b.svg";
export { ForwardRef as ReactComponent };